<template>
  <div class="home">
 
    <!-- Main Content -->
    <div class="main">
      <!-- Welcome Section -->
      <section class="welcome">
        <h2 class="section-title">Welcome Home</h2>
        <p class="welcome__text">
          We invite you to worship with us this Sunday as we grow in grace and truth together. 
          Whether you're new to the faith or a long-time believer, you'll find a welcoming 
          community that desires to know Christ and make Him known.
        </p>
      </section>

      <!-- Service Times & Location -->
      <section class="info-cards">
        <div class="card">
          <div class="card__content">
            <h3 class="card__title">Service Times</h3>
            <div class="services">
              <div class="services__item">
                <i class="fas fa-book-bible"></i>
                <div class="services__details">
                  <p class="services__day">Sunday Bible Study</p>
                  <p class="services__time">8:30 AM</p>
                </div>
              </div>
              <div class="services__item">
                <i class="fas fa-church"></i>
                <div class="services__details">
                  <p class="services__day">Sunday Worship Service</p>
                  <p class="services__time">9:30 AM</p>
                </div>
              </div>
              <div class="services__item">
                <i class="fas fa-child"></i>
                <div class="services__details">
                  <p class="services__day">Sunday School</p>
                  <p class="services__time">9:30 AM</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card__content">
            <h3 class="card__title">Location</h3>
            <div class="services">
              <div class="services__item">
                <i class="fas fa-map-marker-alt"></i>
                <div class="services__details">
                  <p class="services__day">Address</p>
                  <div class="services__address">
                    <p>406 Edward Street, Ohenimuri</p>
                    <p>De Deur, 1876</p>
                  </div>
                  <a href="https://maps.app.goo.gl/c1ihof85AhavyLFP6" 
                     target="_blank" 
                     rel="noopener noreferrer" 
                     class="services__link"
                  >
                    View on Google Maps
                    <i class="fas fa-chevron-right"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card__content">
            <h3 class="card__title">Contact</h3>
            <div class="services">
              <div class="services__item">
                <i class="fas fa-phone"></i>
                <div class="services__details">
                
                  <a href="tel:+27834473685" class="services__time">
                    083 447 3685
                  </a>
                </div>
              </div>
              <div class="services__item">
                <i class="fas fa-envelope"></i>
                <div class="services__details">
                  
                  <a href="mailto:Walkervillebaptist@yahoo.com" class="services__time">
                    Walkervillebaptist@yahoo.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card__content">
            <h3 class="card__title">Our Faith</h3>
            <div class="faith">
              <div class="faith__item">
                <div class="faith__details">
                  <p class="faith__text">Discover what we believe and our Baptist distinctives</p>
                  <div class="faith__button-container">
                    <router-link to="/beliefs" class="faith__button">
                      What We Believe
                      <i class="fas fa-chevron-right"></i>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card__content">
            <h3 class="card__title">Service Schedule</h3>
            <div class="faith">
              <div class="faith__item">
                <div class="faith__details">
                  <p class="faith__text">See who's preaching and leading worship each Sunday</p>
                  <div class="faith__button-container">
                    <router-link to="/schedule" class="faith__button">
                      View Schedule
                      <i class="fas fa-chevron-right"></i>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>

      <!-- Mission Section -->
      <section class="mission">
        <h2 class="section-title">Our Mission</h2>
        <div class="mission__grid">
          <div v-for="(mission, index) in missions" :key="index" class="mission-card">
            <h3 class="mission-card__title">{{ mission.title }}</h3>
            <p class="mission-card__description">{{ mission.description }}</p>
          </div>
        </div>
      </section>

      <!-- Contact Section -->
      <section class="contact">
        <h2 class="section-title">Contact</h2>
        <div class="contact__container">
          <a 
            href="tel:+27834473685"
            class="contact-item"
          >
            <i class="fas fa-phone"></i>
            <span>083 447 3685</span>
          </a>
          <a 
            href="mailto:Walkervillebaptist@yahoo.com"
            class="contact-item"
          >
            <i class="fas fa-envelope"></i>
            <span>Walkervillebaptist@yahoo.com</span>
          </a>
        </div>
      </section>
    </div>

 
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  components: {
    
  },
  data() {
    return {
      missions: [
        {
          title: 'Exalt Christ',
          description: 'Through authentic worship and devotion'
        },
        {
          title: 'Equip Believers',
          description: 'Through sound biblical teaching'
        },
        {
          title: 'Engage the World',
          description: 'With the transforming gospel'
        }
      ],
      contacts: [
        {
          icon: 'fab fa-facebook',
          info: 'Grace Baptist Church Walkerville',
          link: 'https://www.facebook.com/profile.php?id=100064358045061'
        },
        {
          icon: 'fab fa-youtube',
          info: 'Grace Baptist Church Walkerville',
          link: 'https://www.youtube.com/@gracebaptistchurchwalkervil1829'
        }
      ],
      address: 'Edward Street, Ohenimuri, De Deur, 1876'
    }
  }
}
</script>

<style lang="scss" scoped>
// Variables
$primary-color: #1e40af;
$secondary-color: #60a5fa;
$text-dark: #1f2937;
$text-light: #4b5563;
$white: #ffffff;
$spacing-base: 1rem;
$border-radius: 0.5rem;
$transition-base: all 0.3s ease;

// Mixins
@mixin card-shadow {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

@mixin flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

@mixin section-spacing {
  margin-bottom: $spacing-base * 3;
}

// Base Styles
.home {
  min-height: 100vh;
  background: linear-gradient(to bottom, #f0f9ff, $white);
}

// Navigation
.nav {
  background-color: $white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 50;
  
  &__container {
    max-width: 64rem;
    margin: 0 auto;
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__logo {
    font-size: 1.25rem;
    font-weight: 700;
    color: $primary-color;
    text-decoration: none;
  }

  &__links {
    display: flex;
    gap: 1.5rem;
  }

  &__link {
    color: $text-dark;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.3s ease;

    &:hover {
      color: $primary-color;
    }

    &.router-link-active {
      color: $primary-color;
    }
  }
}

// Hero Section
.hero {
  padding-top: 4rem;
  background-color: $primary-color;
  color: $white;
  padding: $spacing-base * 4 0;

  &__container {
    max-width: 64rem;
    margin: 0 auto;
    padding: 0 $spacing-base;
    text-align: center;
  }

  &__logo {
    height: 6rem;
    margin: 0 auto $spacing-base * 1.5;
  }

  &__title {
    font-size: 2.5rem;
    font-weight: 700;
    margin-bottom: $spacing-base;
  }

  &__subtitle {
    font-size: 1.25rem;
    color: rgba($white, 0.9);
    margin-bottom: $spacing-base * 2;
  }

  &__card {
    background: rgba($white, 0.1);
    backdrop-filter: blur(8px);
    border-radius: $border-radius;
    padding: $spacing-base * 1.5;
  }

  &__service-time {
    @include flex-center;
    gap: $spacing-base * 0.5;
    font-size: 1.125rem;
  }
}

// Main Content
.main {
  max-width: 64rem;
  margin: 0 auto;
  padding: $spacing-base * 3 $spacing-base;
}

// Section Title
.section-title {
  font-size: 1.875rem;
  font-weight: 700;
  color: $text-dark;
  text-align: center;
  margin-bottom: $spacing-base * 1.5;
}

// Welcome Section
.welcome {
  @include section-spacing;
  text-align: center;

  &__text {
    font-size: 1.125rem;
    color: $text-light;
    line-height: 1.7;
  }
}

// Info Cards
.info-cards {
  display: grid;
  grid-template-columns: 1fr;
  gap: $spacing-base * 1.5;
  @include section-spacing;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
}

// Card Components
.card {
  background: $white;
  border-radius: $border-radius;
  @include card-shadow;

  &__content {
    padding: $spacing-base * 1.5;
  }

  &__title {
    font-size: 1.25rem;
    font-weight: 600;
    color: $text-dark;
    margin-bottom: $spacing-base;
  }
  &location__map{
    margin: auto;
  }
}

// Service Times
.service-times {
  display: flex;
  flex-direction: column;
  gap: $spacing-base;
}

.service-item {
  display: flex;
  gap: $spacing-base;

  i {
    color: $secondary-color;
    margin-top: 0.25rem;
  }

  &__name {
    font-weight: 500;
    color: $text-dark;
  }

  &__time {
    color: $text-light;
  }
}

// Location
.location {
  text-align: center;

  &__details {
    text-align: left;
    word-break: normal;
    overflow-wrap: break-word;
    max-width: 100%;
  }

  &__address, 
  &__city {
    margin: 0.25rem 0;
    white-space: normal;
    line-height: 1.5;
  }

  &__link {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 0.5rem;
    color: #1e40af;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }

  &__map-link {
    display: block;
    position: relative;
    cursor: pointer;
    
    &:hover .location__map-overlay {
      opacity: 1;
    }
  }

  &__map-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.2s ease;

    span {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      color: white;
      font-weight: 500;
      padding: 0.5rem 1rem;
      border-radius: 0.25rem;
      background: rgba(0, 0, 0, 0.5);

      i {
        font-size: 0.875rem;
      }
    }
  }
}

// Mission Section
.mission {
  @include section-spacing;

  &__grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: $spacing-base * 1.5;

    @media (min-width: 768px) {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}

.mission-card {
  background: $white;
  padding: $spacing-base * 1.5;
  border-radius: $border-radius;
  @include card-shadow;
  text-align: center;

  &__title {
    font-size: 1.125rem;
    font-weight: 600;
    color: $text-dark;
    margin-bottom: $spacing-base * 0.75;
  }

  &__description {
    color: $text-light;
  }
}

// Contact Section
.contact {
  background: #f9fafb;
  border-radius: $border-radius;
  padding: $spacing-base * 2;

  &__container {
    max-width: 32rem;
    margin: 0 auto;
  }

  &__link {
    color: #1e40af;
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: #2563eb;
      text-decoration: underline;
    }
  }
}

.contact-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1rem;
  text-decoration: none;
  color: inherit;
  transition: all 0.2s ease;

  i {
    font-size: 1.25rem;
    color: #1e40af;
    margin: 0;
  }

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
    transform: translateY(-1px);
  }
}

.location-section {
  max-width: 64rem;
  margin: 2rem auto;
  padding: 0 1rem;
}

.location-container {
  padding: 1.5rem;
  background-color: white;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.location-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1e40af;
  margin-bottom: 0.5rem;
}

.location-address {
  color: #4b5563;
  font-size: 1.125rem;
  margin-bottom: 1rem;
  line-height: 1.5;
}

.map-link {
  display: flex;
  align-items: center;
  gap: 1rem;
  color: #1e40af;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;

  &:hover {
    color: #2563eb;
  }
}

.static-map {
  width: 200px;
  height: 100px;
  object-fit: cover;
  border-radius: 0.25rem;
}

@media (max-width: 640px) {
  .static-map {
    width: 100%;
    height: 120px;
  }
  
  .map-link {
    flex-direction: column;
  }
}

.faith {
  text-align: center;

  &__item {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__details {
    text-align: center;
    min-width: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  &__text {
    margin-bottom: 1rem;
    line-height: 1.5;
  }

  &__button-container {
    display: flex;
    justify-content: center;
  }

  &__button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    background-color: #1e40af;
    color: white;
    padding: 0.75rem 1.5rem;
    border-radius: 0.5rem;
    text-decoration: none;
    font-weight: 500;
    transition: all 0.2s ease;

    i {
      color: white;
      font-size: 0.875rem;
      margin: 0;
    }

    &:hover {
      background-color: #2563eb;
      transform: translateY(-1px);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    &:active {
      transform: translateY(0);
    }
  }
}

.services {
  text-align: center;

  &__item {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    margin-bottom: 1rem;

    &:last-child {
      margin-bottom: 0;
    }

    i {
      color: #1e40af;
      font-size: 1.25rem;
      margin-top: 0;
      flex-shrink: 0;
    }
  }

  &__details {
    text-align: left;
    min-width: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__day {
    color: #4b5563;
    font-size: 0.875rem;
    margin-bottom: 0.25rem;
    line-height: 1.2;
  }

  &__time {
    color: #1e40af;
    font-weight: 500;
    line-height: 1.2;
    margin-bottom: 0.25rem;

    &:last-of-type {
      margin-bottom: 0.5rem;
    }
  }

  &__link {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    color: #1e40af;
    text-decoration: none;
    font-weight: 500;
    transition: color 0.2s ease;
    line-height: 1.2;

    &:hover {
      color: #2563eb;
      text-decoration: underline;
    }

    i {
      font-size: 0.875rem;
      margin: 0;
    }
  }

  &__address {
    color: #1f2937;
    margin-bottom: 0.5rem;
    
    p {
      margin: 0;
      line-height: 1.5;
    }
  }
}

.card {
  &__title {
    text-align: center;
    margin-bottom: 1rem;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
</style>